import { useState } from "react"
import { useCheckIfScannedFoodImageChanged } from "features/meal/hooks/useScannedImageUploader"
import { formatInputtingFoodName } from "utils/formater"
import { isFoodInfoChanged } from "features/food/helper/foodHelper"
import {
  IAIScanNutritionFactOption,
  IAIScanPackageFoodOption,
} from "model/food/types/AIScan.types"
import { updateNonIngredientEntryNutritionWhenPortionChange } from "features/food/helper/edamaForm"

const getFoodPayloadFromScannedFood = (
  food: IAIScanPackageFoodOption | IAIScanNutritionFactOption,
): IAIScanPackageFoodOption | IAIScanNutritionFactOption => {
  return {
    name: food.name,
    portion: food.portion,
    unit: food.unit,
    calorie: food.calorie,
    protein: food.protein,
    fat: food.fat,
    carbohydrate: food.carbohydrate,
    gram: food.gram,
    uuid: food.uuid,
    comment: food.comment,
    id: food.id,
    source: food.source,
    isSelected: food.isSelected,
  }
}

const useScannedPackageFoodForm = (
  initFood: IAIScanPackageFoodOption | IAIScanNutritionFactOption,
) => {
  const isImageChanged = useCheckIfScannedFoodImageChanged(initFood.id)

  const [food, setFood] = useState(() =>
    getFoodPayloadFromScannedFood(initFood),
  )

  const onNameChange = (name: string) => {
    const formattedName = formatInputtingFoodName(name)
    setFood({ ...food, name: formattedName })
  }

  const onPortionChange = (portion: number) => {
    const nutrition = updateNonIngredientEntryNutritionWhenPortionChange(food, portion)

    setFood({ ...food, portion, ...nutrition })
  }

  const onUnitChange = (unit: string) => {
    setFood({ ...food, unit })
  }

  const onCaloriesChange = (calories: number) => {
    setFood({ ...food, calorie: calories })
  }

  const onProteinChange = (protein: number) => {
    setFood({ ...food, protein })
  }

  const onFatChange = (fat: number) => {
    setFood({ ...food, fat })
  }

  const onCarbohydrateChange = (carbohydrate: number) => {
    setFood({ ...food, carbohydrate })
  }

  const isFoodChanged = () => {
    return isImageChanged || isFoodInfoChanged(initFood, food)
  }

  return {
    food,
    onNameChange,
    onPortionChange,
    onUnitChange,
    onCaloriesChange,
    onProteinChange,
    onFatChange,
    onCarbohydrateChange,
    isFoodChanged,
  }
}

export default useScannedPackageFoodForm
